<template>
  <div class="war-room-post-list-sidebar">
    <BravadoButtonV3
      full-width
      variant="primary"
      data-test="posts_list_create_button"
      @click.native.prevent="handleCreatePostClick"
    >
      <template #prepend-icon>
        <EditIcon width="20" height="20" />
      </template>
      Create a post
    </BravadoButtonV3>
    <WarRoomProfileBanner class="war-room-post-list-sidebar__profile-banner" />
    <ClientOnly>
      <WarRoomMobileAppBannerAside class="war-room-post-list-sidebar__mobile-app-banner" />
      <WarRoomCommissionEarnBanner class="war-room-post-list-sidebar__commission-section" />
    </ClientOnly>
    <WarRoomTopics :topics="popular_topics" data-test="post_list_topics" class="war-room-post-list-sidebar__section" />
    <WarRoomRules :expanded="false" data-test="posts_list_rules" class="war-room-post-list-sidebar__section" />
    <SidebarFooter />
  </div>
</template>

<script lang="ts" setup>
import { computed, useContext, useRouter, useStore } from '@nuxtjs/composition-api';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import SidebarFooter from '@/components/global/SidebarFooter/SidebarFooter.vue';
import EditIcon from '@/assets/svg/edit-action.vue.svg';
import WarRoomCommissionEarnBanner from '@/components/partials/war-room/WarRoomCommissionEarnBanner/WarRoomCommissionEarnBanner.vue';
import WarRoomMobileAppBannerAside from '@/components/partials/war-room/WarRoomMobileAppBanner/WarRoomMobileAppBannerAside/WarRoomMobileAppBannerAside.vue';
import WarRoomRules from '@/components/partials/war-room/WarRoomRules.vue';
import WarRoomTopics from '@/components/partials/war-room/WarRoomTopics.vue';
import WarRoomProfileBanner from '@/components/partials/war-room/WarRoomProfileBanner/WarRoomProfileBanner.vue';
import type { RootState } from '~/types/store';

const { $analytics } = useContext();
const router = useRouter();
const store = useStore<RootState>();

const popular_topics = computed(() => store.state.warRoom.popular_topics);

function handleCreatePostClick() {
  $analytics?.logEvent('war-room__create-a-post-button__click');
  router.push({ name: 'war-room-posts-new' });
}
</script>

<style scoped lang="scss">
.war-room-post-list-sidebar {
  &__section {
    background-color: var(--theme-color-border);
    margin-top: 16px;
  }

  &__commission-section {
    margin-top: 16px;
  }

  &__mobile-app-banner {
    margin-top: 16px;
  }

  &__profile-banner {
    margin-top: 16px;
  }
}
</style>
